<template>
    <div>
        <question-one></question-one>
        <question-two></question-two>
        <question-three></question-three>
        <question-four></question-four>
        <!-- v-bind:class="{ 'is--disabled': this.$store.state.variables.connectionType === 'small' } -->
        <router-link to="/details/" class="button--main">Volgende stap</router-link>
    </div>
</template>

<script>
import QuestionOne from './Q1'
import QuestionTwo from './Q2'
import QuestionThree from './Q3'
import QuestionFour from './Q4'

export default {
  name: 'Introduction',
  components: {
    'question-one': QuestionOne,
    'question-two': QuestionTwo,
    'question-three': QuestionThree,
    'question-four': QuestionFour
  },
  mounted: function () {
    if (window.location.href.indexOf('dakgrootte=') !== -1) {
      const size = parseInt(window.location.href.split('=')[1].replace('#/', ''))
      this.$store.commit('setFlatRoofSurface', size)
    }
  }
}
</script>

<style>

/* TODO: Import locally */
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');
@import url('https://use.fontawesome.com/releases/v5.4.1/css/all.css');

.calculator--y * {
    box-sizing: border-box;
}

.calculator--y .u--defaultColor {
    color: #FFDA00;
}
.calculator--y.calculator {
    width: 760px;
    max-width: 760px;
    padding: 30px;
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
}

.calculator--y .question h2 {
    font-weight: 700;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 10px;
}
.calculator--y .question .description {
    margin-bottom: 20px;
}

.calculator--y .rangeInput {
    display: flex;
}

.calculator--y .rangeInput-slider {
    flex: 1;
    padding: 8px 20px 0 30px;
}

.calculator--y .rangeInput-slider.no--paddingLeftSide {
    padding: 8px 20px 0 0;
}

.calculator--y .tooltip {
    background-color: #363736;
    color: #fff;
    font-weight: bold;
    display: flex;
    border-radius: 3px;
    padding: 0 10px;
    height: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 12px;
    line-height: 20px;
}

.calculator--y .tooltip span {
    white-space: nowrap;
}

.calculator--y .tooltip:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.calculator--y .tooltip:before {
    border-color: transparent;
    border-top-color: #363736;
    border-width: 4px;
    margin-left: -4px;
}

.calculator--y .input-type {
    background-color: #fff;
    height: 48px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 0 15px 0 5px;
    display: flex;
    align-items: center;
    border: 1px solid #a5b5c7;
    border-left: none;
    font-size: 16px;
    font-weight: 500;
    color: #818991;
}

.calculator--y .input {
    height: 48px;
    border: 1px solid #a5b5c7;
    border-right: 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 3px 20px 0 20px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    box-sizing: border-box;
    width: 110px;
}

.calculator--y .calculator__inner {
    padding: 30px;
    background-color: #fff;
}

.calculator--y .description {
    display: flex;
}

.calculator--y .column {
    flex: 1;
}

.calculator--y .button--main {
    background-color: #02b151;
    box-shadow: 0 -3px 0 0 inset #029845;
    color: #fff;
    padding: 0 30px;
    height: 50px;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
    border-radius: 5px;
    margin-top: 40px;
    display: inline-flex;
    align-items: center;
}

.calculator--y .button--main:hover {
  background-color: #009343;
  box-shadow: 0 -1px 0 0 inset #007a37;
}

.calculator--y .button--main:focus {
  background-color: #007C38;
  box-shadow: none;
}

.calculator--y .button--main.is--disabled {
    pointer-events: none;
    opacity: 0.6;
}

.calculator--y .button--secondary {
    border: 1px solid #363736;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    color: #363736;
    background: transparent;
    text-decoration: none;
    padding: 0 20px;
    border-radius: 5px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    font-weight: bold;
}

.calculator--y .button--secondary:hover {
    background: rgba(0, 0, 0, 0.04);
    border-color: #000000;
    color: #000000;
    box-shadow: none!important;
}

.calculator--y .result-header,
.calculator--y .details-header {
    display: flex;
    align-items: center;
    margin: 0 0 30px;
}

.calculator--y .details-header {
    margin: 0 0 20px;
}

.calculator--y .result-header h2,
.calculator--y .details-header h2 {
    margin-top: 0;
    flex: 1;
}

.calculator--y .result-blocks {
    display: flex;
}

.calculator--y .result-block {
    padding: 20px;
    background-color: rgba(51,199,117, 0.1);
    flex: 1;
    min-height: 250px;
    margin: 0 20px 0 0;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}

.calculator--y .result-block:last-child {
    margin: 0;
}

.calculator--y .result-block-icon {
    font-size: 40px;
    background-color: rgba(51,199,117, 1);
    color: #fff;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px;
}

.calculator--y .result-block-icon-container {
    flex: 1;
}

.calculator--y .result-block-value {
    color: rgba(51,199,117, 1);
    font-size: 30px;
    font-weight: bold;
    margin: 0 0 10px;
    white-space: nowrap;
}

.calculator--y .result-block-desc {
    font-size: 16px;
    color: #000;
}

.calculator--y .call-to-action {
    justify-content: center;
    align-items: center;
}

.calculator--y .check-list {
    margin: 20px 0;
    padding: 0;
    list-style-type: none;
}

.calculator--y .check-list li {
    margin: 0 0 10px;
}

.calculator--y .check-list li span {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: rgba(51,199,117, 0.1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: rgba(51,199,117, 1);
    font-size: 12px;
    margin: 0 10px 0 0;
}

.calculator--y .radio-group {
    display: flex;
}

.calculator--y .icon {
    flex: 1;
    color: #6a787c;
    display: flex;
    align-items: center;
    font-size: 22px;
    justify-content: center;
}

.calculator--y .radio-item {
    height: 130px;
    display: flex;
    flex-direction: column;
    padding: 15px;
    box-sizing: border-box;
    font-weight: 500;
    border: 1px solid #d0d8e0;
    display: flex;
    border-radius: 5px;
    margin: 0 20px 0 0;
    position: relative;
    font-size: 16px;
    text-align: center;
    color: #000;
    font-weight: 500;
    flex: 1;
}

.calculator--y .radio-item:last-child {
  margin-right: 0;
}

.calculator--y .radio-item.is--active {
  border: 1px solid #ffda00;
  background-color: rgba(255, 218, 0, 0.1);
  transition: 0.5s all;
}


.calculator--y .radio-item.is--active .icon {
    color: rgb(252, 202, 3);
}

.calculator--y .radio-item input {
    display: none;
}

.calculator--y .numberInput {
    display: flex;
}

.calculator--y .choice {
    display: flex;
    width: 100%;
    padding-bottom: 20px;
    transition: all 0.5s;
}

.calculator--y .choice .choice-range {
    transition: all 0.5s;
    opacity: 0.8;
}

.calculator--y .choice.is--active .choice-range {
    opacity: 1;
}
.calculator--y .choice-checkbox input[type=checkbox] {
    display: none;
}
.calculator--y .choice.is--active .title {
    background-color: #FFDA00;
    transition: all 0.5s;
    color: #fff;
}

.calculator--y .choice.is--active .choice-checkbox {
    background-color: #fef4cd;
    transition: 0.5s all;
}

.calculator--y .icon {
    flex: 1;
    color: #6a787c;
    display: flex;
    align-items: center;
    font-size: 22px;
}

.calculator--y .choice.is--active .icon {
    color: rgb(252, 202, 3);
}
.calculator--y .title {
    background-color: #dbe3e5;
    height: 30px;
    width: 100%;
    font-size: 16px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #6a787c;
    font-weight: 500;
}

.calculator--y .choice-range {
    flex: 1;
    width: 100%;
    height: 80px;
    padding-top: 20px;
}
.calculator--y .choice-checkbox {
    cursor: pointer;
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #eff3f5;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 5px;
    position: relative;
}

.calculator--y .option {
    margin-right: 20px;
}

.calculator--y .question__inner {
    display: flex;
}

.calculator--y label {
    margin: 0 0 7px;
    display: block;
    color: #000;
    font-weight: 500;
}

.calculator--y .details-question {
    margin: 0 0 30px;
}

.calculator--y .details-question-columns {
    display: flex;
}

.calculator--y .details-question-column {
    flex: 1;
}

.calculator--y .details-question-column:first-child {
    margin: 0 50px 0 0;
}

.calculator--y .details-question label {
    display: block;
    font-size: 1.75rem;
    margin-bottom: 5px;
    line-height: 1.166em;
    font-weight: 700;
    color: #252525;
    font-size: 16px;
    font-weight: 400;
}

.calculator--y .calculator__label .required-icon {
    margin: 0 0 0 5px;
}

.calculator--y .details-question .form__input[type=text],
.calculator--y .details-question .form__input[type=email],
.calculator--y .details-question .form__input[type=tel] {
    border-radius: 4px;
    height: 48px;
    font-size: 16px;
    padding: 0 20px;
    font-weight: 400;
    border: 1px solid #d0d8e0;
    box-sizing: border-box;
    width: 100%;
    position: relative;
}

.calculator--y .details-question .form__input[type=text]:focus,
.calculator--y .details-question .form__input[type=email]:focus,
.calculator--y .details-question .form__input[type=tel]:focus {
  border-color: #ffda00;
  transition: 0.3s box-shadow;
  box-shadow: 0 0 0 2px #ffda00;;
}

.calculator--y .details-question .form__radio-group {
    margin: 10px 0 0 0;
    display: flex;
}

.calculator--y .details-question .form__radio {
    margin-right: 30px;
    display: block;
    position: relative;
    cursor: pointer;
    user-select: none;
}

.calculator--y .details-question .form__radio span {
    display: flex;
    align-items: center;
    z-index: 1;
}

.calculator--y .details-question .form__radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 100%;
    z-index: 2;
}

.calculator--y .details-question .form__radio label {
    margin: 0;
}

.calculator--y .details-question .form__radio .custom_radio {
    display: block;
    background: #FFFFFF;
    border: 1px solid silver;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    line-height: 2.5625rem;
    box-sizing: border-box;
    resize: vertical;
    outline: none;
    font-weight: normal;
    width: 20px;
    height: 20px;
    margin-right: 0.66rem;
    position: relative;
    top: -1px;
}

.calculator--y .details-question .form__radio input:checked ~ span .custom_radio {
    background: #FFFFFF;
    border: 6px solid #f4cb2f;
}

.calculator--y .form__select {
    width: 100%;
    border: 1px solid silver;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    line-height: 2.5625rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    resize: vertical;
    outline: none;
    padding: 0 0.5rem;
    font-weight: normal;
    position: relative;
    background: none!important;
}

.calculator--y .form__select:after {
    position: absolute;
    right: 12px;
    top: 12px;
    content: "\f107";
    font-family: "Font Awesome 5 Free";
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-weight: 900;
    font-size: 20px;
}

.calculator--y .form__select select {
    padding: 5px 8px;
    width: 130%;
    border: none;
    box-shadow: none;
    background-color: transparent;
    background-image: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    z-index: 2;
    position: relative;
    outline: none;
}

.calculator--y .details-call-to-action {
    display: flex;
    align-items: center;
    margin-top: 40px;
}

.calculator--y .details-call-to-action .call-to-action-privacy {
    flex: 1;
}

.calculator--y .details-call-to-action .button--main {
    margin-top: 0;
}

.calculator--y .call-to-action-privacy {
    border-radius: 5px;
    font-size: 12px;
    color: #555;
    line-height: 1.6;
    margin: 0 30px 0 0;
}

.calculator--y .call-to-action-privacy a {
    color: rgba(16, 91, 195, 1);
    text-decoration: none;
}

/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */button,hr,input{overflow:visible}progress,sub,sup{vertical-align:baseline}[type=checkbox],[type=radio],legend{box-sizing:border-box;padding:0}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:ButtonText dotted 1px}fieldset{padding:.35em .75em .625em}legend{color:inherit;display:table;max-width:100%;white-space:normal}textarea{overflow:auto}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}

@media (max-width: 992px) {
    .calculator--y.calculator {
        width: 100%;
        padding: 10px;
    }
    .calculator--y .rangeInput-slider {
        display: none;
    }
    .calculator--y .rangeInput .input {
        margin-left: 15px;
    }
    .calculator--y .no--paddingLeftSide + .input {
        margin-left: 0;
    }
    .calculator--y .result-header {
        flex-direction: column;
        align-items: flex-start;
    }
    .calculator--y .result-blocks {
        flex-direction: column;
    }
    .calculator--y .result-block {
        margin: 0 0 20px 0;
    }
    .calculator--y .button--main {
        font-size: 16px;
    }
    .calculator--y .details-question-columns {
        flex-direction: column;
    }
    .calculator--y .details-question-column {
        margin: 20px 0 0 0;
        width: 100%;
    }
    .calculator--y  .details-call-to-action  {
        flex-direction: column;
    }

    .calculator--y  .call-to-action-privacy {
        margin: 0 0 20px;
    }

    .calculator--y .details-call-to-action .button--main {
        text-align: center;
    }

    .calculator--y .details-header {
        flex-direction: column;
    }

    .calculator--y .radio-item {
      font-size: 12px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue